import { Loader } from '@googlemaps/js-api-loader';

const apiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

if (!apiKey) {
  console.error('[Google Maps] Missing API key. Set REACT_APP_GOOGLE_MAP_KEY in your environment variables.');
}

const loader = new Loader({
  apiKey,
  version: 'weekly',
  libraries: ['places'],
});

export default loader;
